// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__HPqEC","description":"PatientConsentPreview_description__1YUdh"};